module.exports = __webpack_public_path__ + "img/full2-min.b6b3c81f.png";